import * as React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { PermissionMatrixPage, SYSTEM_ROLE_CODE } from '@ooh/screens';
import { ME_CONTEXT_QUERY_KEY } from '../../hooks/use-context-query';
import { PageTitleContext } from '../__root';

// ─── Route ───────────────────────────────────────────────────

export const Route = createFileRoute('/admin/permissions')({
  beforeLoad: ({ context }) => {
    const user = context.auth.user;
    if (!user || !user.roles.includes(SYSTEM_ROLE_CODE)) {
      throw redirect({ to: '/media-units' });
    }
  },
  component: PermissionsRoute,
});

function PermissionsRoute() {
  const { setPageTitle } = React.useContext(PageTitleContext);
  const { t } = useTranslation('admin');
  const queryClient = useQueryClient();

  React.useEffect(() => {
    setPageTitle(t('permissionMatrix.header.title'));
  }, [setPageTitle, t]);

  return (
    <PermissionMatrixPage
      onPermissionsSaved={() =>
        void queryClient.invalidateQueries({ queryKey: ME_CONTEXT_QUERY_KEY })
      }
    />
  );
}
